module.exports = __webpack_public_path__ + "img/bookmark.9b5e5dce.svg";